import React, { useMemo } from 'react';
import useStats from '../hooks/useStats';
import StatsTable from './common/StatsTable';
import TIME_PERIODS from './constants/periods';

const RESOURCE = '/v1/statistics/emails';
const INITIAL_STATE = {};

const EmailStats = () => {
  const { data: emailStats, loading } = useStats({
    resource:     RESOURCE,
    initialState: INITIAL_STATE,
  });

  const columns = useMemo(() => [
    { header: 'Emails', id: 'emails' },
    { header: 'Sent', id: 'sent', className: 'text-center' },
    { header: 'Received', id: 'received', className: 'text-center' },
  ], []);

  const rows = useMemo(() => [
    {
      period: TIME_PERIODS.TODAY,
      values: [
        { id: 'email-sent-today', value: emailStats.sentEmailsToday },
        { id: 'email-received-today', value: emailStats.receivedEmailsToday },
      ],
    },
    {
      period: TIME_PERIODS.THIS_WEEK,
      values: [
        { id: 'email-sent-week', value: emailStats.sentEmailsThisWeek },
        { id: 'email-received-week', value: emailStats.receivedEmailsThisWeek },
      ],
    },
    {
      period: TIME_PERIODS.THIS_MONTH,
      values: [
        { id: 'email-sent-month', value: emailStats.sentEmailsThisMonth },
        { id: 'email-received-month', value: emailStats.receivedEmailsThisMonth },
      ],
    },
    {
      period: TIME_PERIODS.LAST_MONTH,
      values: [
        { id: 'email-sent-last-month', value: emailStats.sentEmailsLastMonth },
        { id: 'email-received-last-month', value: emailStats.receivedEmailsLastMonth },
      ],
    },
  ], [emailStats]);

  return (
    <StatsTable
      title="Emails"
      columns={columns}
      rows={rows}
      loading={loading}
    />
  );
};

export default React.memo(EmailStats);
